import {FormKnowYouMobile} from "./FormKnowYouMobile";
import {FormCreditSimulatorMobile} from "./FormCreditSimulatorMobile";
import {FormKnowYou} from "./FormKnowYou";
import {FormCreditSimulator} from "./FormCreditSimulator";
import {useRequestContext} from '../../../hooks/useRequestContext';
import {Desktop, LandscapePhonesAndSmaller, LandscapeTablet, TabletAndMinis} from "../../../utils/breakpoints";
import "./request-info.scss";

interface FinancialInformationContainerProps {
    typeIdentification?: string,
    identification?: string,
    costProduct?: string,
    nameProduct?: string,
    errors?: any,
    values?: any,
}

export function RequestInfoContainer(props: FinancialInformationContainerProps) {
    const {errors, values} = props;
    const {request, setRequest} = useRequestContext();
    return (
        <>
            <Desktop>
                <div className={`flex-container-simulator${request.imagemoto ? '' : ' flex-container-simulator-sin-producto'}`}>
                    {request.imagemoto ? (
                    <div className="flex-item-left-simulator">
                        <div className="request-visual-card">
                            <img className="d-none d-xl-block borderRadius" src={request.imagemoto} alt={''}/>
                        </div>
                    </div>
                    ) : null}
                    <div className="flex-item-right-simulator">
                        <div className="request-info-card">
                            <FormKnowYou errors={errors} values={values}/>
                            <FormCreditSimulator errors={errors} values={values}/>
                        </div>
                    </div>
                </div>
            </Desktop>
            <LandscapeTablet>
                <>
                    <FormKnowYou errors={errors} values={values}/>
                    <FormCreditSimulator errors={errors} values={values}/>
                </>
            </LandscapeTablet>
            <LandscapePhonesAndSmaller>
                <>
                    <FormKnowYouMobile errors={errors} values={values}/>
                    <FormCreditSimulatorMobile errors={errors} values={values}/>
                </>
            </LandscapePhonesAndSmaller>
        </>
    )
}
